export default __webpack_public_path__ + "52576b6500d12e28dec77d406c2eb4c6.png";